<template>
  <div class="freeEditorial freeEditorialParsys parsys">
    <div class="contentZone section">
      <div class="content-zone container">
        <div class="link-zone">
          <div class="title">
          </div>
          <div class="columns parsys">
            <div class="columns column section columns12">
              <div class="grid-row">
                <div class="col-12">
                  <div class="pageHeader">
                    <div class="c_023 ">
                      <div class="container-inner">
                        <div class="c_023-1 default">
                          <div class="heading-group">
                            <h2><span>{{$store.state.form.user.title}} {{$store.state.form.user.name}}, hvala vam na interesu!</span></h2>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="grid-row">
                <div class="col-12">
                  <div class="parsys col1-par">
                    <div class="dynamicThankyou section">
                      <div class="c_026" data-lead-id="RSIJHAIWVRH">
                        <div class="text-content" data-lead-id="RSIJHAIWVRH">
                          <p style="font-size: 18px;">Veselimo se što  možemo s vama podijeliti najnovije novosti o Nissan vozilima!<br>
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import $ from 'jquery'

export default {
  name: 'Form',
  data () {
    return {
    }
  },
  mounted () {
    $('html, body').animate({
      scrollTop: 30
    }, 600)
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
h2,p {
    font-family: "Nissan Regular", Verdana, Arial, sans-serif;
  }
</style>



// WEBPACK FOOTER //
// src/components/ThankYou.vue